import usePaging from "../../../hooks/usePaging";
import { useGetAssessmentsPendingQuery } from "../assessmentsSlice";
import { useLocation } from "react-router-dom";
import useHasAccess from "../../../hooks/useHasAccess";
import useRefresher from "../../../hooks/useRefresher";

const useAssessmentsPending = () => {
  const { activePage } = usePaging({});
  const location = useLocation();
  const hasAccess = useHasAccess({
    apiCall: "assessments.GET",
  });

  const assessments = useGetAssessmentsPendingQuery({
    page: location?.pathname?.includes("assessments_pending") ? activePage : 1,
  });
  useRefresher(assessments)

  return {
    ...assessments,
    data: assessments?.data?.response,
    pagination: assessments?.data?.pagination,
    hasAccess,
  };
};

export default useAssessmentsPending;
